// mutations.js

export default {
    updateTasksList(state, tasksList){
        state.tasksList = tasksList
    },
    updateTask(state, payload){
        let task = state.tasksList.find(item=>item.id === payload.id)
        if(payload.viewed_at){
            task.viewed_at = payload.viewed_at
        }
        if(payload.status){
            task.status = payload.status
        }
        console.log('updateTask', task)
    },
    removeTaskFromList(state, taskId){
        state.tasksList = state.tasksList.filter(task => task.id !== taskId)
    }
};
